import {useMemo} from 'react'

import PropTypes from 'prop-types'

import {BASE_CLASS} from '../../config.js'
import PanelPriceIndicatorRank from '../Rank/index.js'

const PanelPriceIndicatorRanks = ({ranks}) => {
  const ranksList = useMemo(
    () =>
      ranks.map(({color, isHighlighted, label}) => {
        return <PanelPriceIndicatorRank color={color} label={label} isHighlighted={isHighlighted} />
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return <div className={`${BASE_CLASS}-ranks`}>{ranksList}</div>
}

PanelPriceIndicatorRanks.displayName = 'PanelPriceIndicatorRanks'

PanelPriceIndicatorRanks.propTypes = {
  ranks: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string
    })
  )
}

export default PanelPriceIndicatorRanks
